(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const MODAL_FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';
  let lastModalTrigger = null;

  const setModalState = (modal, isOpen) => {
    if (!modal) return;

    const header = document.querySelector('.shopify-section-group-header-group');
    const footer = document.querySelector('.shopify-section-group-footer-group');
    const socialFeedSections = document.querySelectorAll('.shopify-section:has(.blj-social-feed)');

    if (isOpen) {
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pl-modal-open');
      if (header) header.classList.add('pl-modal-header-hidden');
      if (footer) footer.classList.add('pl-modal-footer-hidden');
      socialFeedSections.forEach((section) => section.classList.add('pl-modal-social-hidden'));

      const focusTarget = modal.querySelector('.pl-modal__close') || modal.querySelector(MODAL_FOCUSABLE_SELECTOR);
      if (focusTarget instanceof HTMLElement) {
        focusTarget.focus();
      }
      return;
    }

    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pl-modal-open');
    if (header) header.classList.remove('pl-modal-header-hidden');
    if (footer) footer.classList.remove('pl-modal-footer-hidden');
    socialFeedSections.forEach((section) => section.classList.remove('pl-modal-social-hidden'));

    if (lastModalTrigger instanceof HTMLElement) {
      lastModalTrigger.focus();
      lastModalTrigger = null;
    }
  };

  // Fallback: open filters drawer on mobile even if custom CSS changed click behavior
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.facets-toggle__button');
    if (!btn) return;

    const drawerHost = document.getElementById('filters-drawer');
    if (!drawerHost) return;

    const dialog = drawerHost.querySelector('dialog');
    if (!(dialog instanceof HTMLDialogElement)) return;

    event.preventDefault();

    if (!dialog.open) {
      dialog.showModal();
    }
  });


  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  // Prevent routing on click and instead open modal (Event Delegation)
  document.addEventListener('click', (e) => {
    // Open Modal
    const cardBtn = e.target.closest('.pl-card-btn');
    if (cardBtn) {
      e.preventDefault();
      lastModalTrigger = cardBtn;
      const card = cardBtn.closest('.pl-card');
      const productId = card.getAttribute('data-product-id');
      const modal = document.getElementById(`plModal-${productId}`);
      
      setModalState(modal, true);
    }

    // Close Modal
    const closeBtn = e.target.closest('.pl-modal__close') || e.target.closest('.pl-modal__backdrop') || e.target.closest('[data-close-modal]');
    if (closeBtn) {
      e.preventDefault();
      const modal = closeBtn.closest('.pl-modal');
      setModalState(modal, false);
    }
  });

  // Close custom product modal before opening the theme quick-add modal.
  document.addEventListener('click', (event) => {
    const chooseBtn = event.target.closest('.pl-modal .quick-add__button--choose');
    if (!chooseBtn) return;

    const modal = chooseBtn.closest('.pl-modal');
    if (!modal) return;
    setModalState(modal, false);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openModal = document.querySelector('.pl-modal[aria-hidden="false"]');
    if (!openModal) return;

    setModalState(openModal, false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;

    const openModal = document.querySelector('.pl-modal[aria-hidden="false"]');
    if (!openModal) return;

    const focusable = Array.from(openModal.querySelectorAll(MODAL_FOCUSABLE_SELECTOR)).filter((el) => {
      return el instanceof HTMLElement && !el.hasAttribute('disabled');
    });
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;

    if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  });

  // Pack Size chip toggle - clicking a chip marks it as active
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('.pl-chip');
    if (chip) {
      const chipRow = chip.closest('.pl-chip-row');
      if (chipRow) {
        chipRow.querySelectorAll('.pl-chip').forEach(c => c.classList.remove('is-active'));
        chip.classList.add('is-active');
      }
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const sectionRoot = document.querySelector('[data-collection-section-id="{{ section.id }}"]');
    if (!sectionRoot) return;

    sectionRoot.addEventListener(
      'click',
      (event) => {
        const item = event.target.closest('.product-grid__item');
        if (!item) return;

        if (event.target.closest('.pl-card-btn, .pl-modal, .pl-chip')) return;
        if (event.target.closest('.quick-add__button--choose')) return;

        const chooseButton = item.querySelector('.quick-add__button--choose');
        if (!chooseButton) return;

        event.preventDefault();
        event.stopPropagation();
        chooseButton.click();
      },
      true
    );
  });

  const initModalDescriptionScrollbar = (scope = document) => {
    if (typeof window.SimpleBar === 'undefined') return;
    const targets = scope.querySelectorAll('[data-pl-modal-description-scroll]');
    targets.forEach((target) => {
      if (target.hasAttribute('data-simplebar')) return;
      target.setAttribute('data-simplebar', '');
      target.setAttribute('data-simplebar-auto-hide', 'true');
      target.setAttribute('data-simplebar-force-visible', 'false');
      if (window.SimpleBar.instances && window.SimpleBar.instances.get(target)) return;
      new window.SimpleBar(target, { autoHide: true });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initModalDescriptionScrollbar(document));
  document.addEventListener('shopify:section:load', (event) => initModalDescriptionScrollbar(event.target));

  } catch(e) { console.error(e); }
})();
})();
